import Helpers from '../helpers/Helpers.js'

class RemoveWhenOutside {
    constructor (theme, elem) {
        this._elem = elem
        this._options = Object.assign({
            classToRemove: '',
            ignoreElems: []
        }, JSON.parse(this._elem.dataset[Helpers.camelize(this.constructor.name)] ? this._elem.dataset[Helpers.camelize(this.constructor.name)] : '{}'))
    }

    onInit () {
        document.addEventListener('click', e => {
            let shouldBeIgnored = false
            for (let selector of this._options.ignoreElems) {
                if (e.target.matches(selector) || Helpers.hasParent(e.target, selector)) {
                    shouldBeIgnored = true
                    break
                }
            }
            if (e.target !== this._elem && !Helpers.hasParentElem(e.target, this._elem) && !shouldBeIgnored) {
                this._elem.classList.remove(this._options.classToRemove)
            }
        })
    }
}

export default RemoveWhenOutside



// WEBPACK FOOTER //
// ./src/resources/scripts/components/RemoveWhenOutside.js